<div [matMenuTriggerFor]="userActions" class="flex items-center w-full px-6 py-4 border-t cursor-pointer">
    <!-- Button -->
    <button mat-icon-button>
        <span class="relative">
            <img class="w-9 h-9 rounded-full" *ngIf="user?.photo" [src]="env.node + '/uploads/signed?key=' + user.photo + '&token=' + authService.nodeToken">
            <mat-icon class="icon-size-5" *ngIf="!user?.photo" [svgIcon]="'awesome_light:circle-user'"></mat-icon>
        </span>
    </button>

    <div class="flex flex-col w-full ml-2 overflow-hidden">
        <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current opacity-80" [ngClass]="{'text-white': layoutAdmin}">
            {{user.name}}
        </div>
        <div class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50" [ngClass]="{'text-white': layoutAdmin}">
            {{user.email}}
        </div>
    </div>

    <mat-icon class="icon-size-4 ml-2" [ngClass]="{'text-white': !isCondominiumPage, 'text-primary': isCondominiumPage}" [svgIcon]="'awesome_solid:chevron-down'"></mat-icon>
</div>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Logado como</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <ng-container *ngIf="layoutAdmin">
        <mat-divider class="my-2"></mat-divider>
        <button [routerLink]="'/dashboard'" mat-menu-item>
            <mat-icon class="icon-size-4.5 text-gray-800" [svgIcon]="'awesome_solid:building'"></mat-icon>
            <span class="text-sm">Ir para o Cipa Fácil</span>
        </button>
    </ng-container>
    <ng-container *ngIf="!layoutAdmin">
        <mat-divider class="my-2"></mat-divider>
        <button *ngIf="hasPermissionAdminView" mat-menu-item [routerLink]="['/admin']">
            <mat-icon class="icon-size-4.5 text-gray-800" [svgIcon]="'awesome_solid:user-shield'"></mat-icon>
            <span class="text-sm">Ir para o Painel Administrativo</span>
        </button>
    </ng-container>
    <ng-container *ngIf="!isCondominiumPage">
        <mat-divider class="my-2"></mat-divider>
        <button [routerLink]="['/configuracoes']" mat-menu-item>
            <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_light:circle-user'"></mat-icon>
            <span>Perfil</span>
        </button>
        <button *ngIf="this.appService.hasPermission('settings_collaborator_view')" [routerLink]="['/configuracoes/users']" mat-menu-item>
            <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_solid:user-edit'"></mat-icon>
            <span>Usuários</span>
        </button>
    </ng-container>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_solid:sign-out-alt'"></mat-icon>
        <span>Sair</span>
    </button>
</mat-menu>

